import { Attributes, SpanOptions } from "@opentelemetry/api";

import { TelemetryManager } from "../opentelemetry/TelemetryManager";

export const useRenderTracing = (
  operationName: string,
  attributes?: Attributes,
  options?: SpanOptions
) => {
  const span = TelemetryManager.get().startManagedSpan(
    operationName,
    attributes,
    options
  );
  return () => {
    TelemetryManager.get().endManagedSpan(span!);
  };
};
